import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TCreativeRowAction } from '../columns/creativeColumns';
import type { ISampleCreative } from '../sampleData';
import RowActionsMenu from './RowActionsMenu';

interface IProps {
  creative: ISampleCreative;
  onAction: (creative: ISampleCreative, action: TCreativeRowAction) => void;
}

function CreativeRowActions({ creative, onAction }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const archiveOrRestore = creative.archived
    ? { action: 'return' as const, label: t('Restore') }
    : { action: 'archive' as const, isDestructive: true, label: t('Archive') };

  return (
    <RowActionsMenu
      actions={[
        { action: 'preview', label: t('Preview') },
        {
          ...archiveOrRestore,
          showDividerBefore: true,
        },
        { action: 'delete', isDestructive: true, label: t('Delete') },
      ]}
      onAction={(action): void => {
        const mapped: TCreativeRowAction =
          action === 'return' ? 'restore' : (action as TCreativeRowAction);
        onAction(creative, mapped);
      }}
    />
  );
}

export default CreativeRowActions;
